import React from "react";
import { useMediaQuery, Box, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import CardComponent from "../InternalPages/Carousal-ExpandedView/CardComponent";
import ListViewDesign from "../InternalPages/ListView/ListViewDesign";
import NoRecordFounds from "../../utils/NoRecordsFound";
import withCommonCardLogic from "../../hoc/ModifiedView";

const EnhancedCard = withCommonCardLogic(CardComponent);

export default function SearchItems({
  grid,
  content,
  items = [],
  setLoading,
  isLoadingMore = false,
  initialLoaded = false,
}) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isDarktheme = useSelector((state) => state.theme);

  // 🔹 2. No results (ONLY after initial load)
  if (initialLoaded && items?.length === 0 && !isLoadingMore) {
    return <NoRecordFounds data-testid="no-records-found" />;
  }

  // 🔹 3. Render items
  return (
    <div>
      {grid === "tile" ? (
        <Box
          sx={{
            backgroundColor: isMobile && !isDarktheme ? "white" : "none",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            padding: { xs: "16px", md: "none" },
            gap: { xs: "16px", md: "8px" },
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          {items.map((item) => (
            <EnhancedCard
              key={item.id}
              card={item}
              content={content}
              setLoading={setLoading}
              flexDirection="column"
              chapter
            />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: isMobile && !isDarktheme ? "white" : "none",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            padding: { xs: "16px", md: "none" },
            gap: { xs: "16px", md: "24px" },
            flexWrap: "wrap",
          }}
        >
          <ListViewDesign data={items} content={content} chapter />
        </Box>
      )}

      {/* Infinite scroll loader */}
      {isLoadingMore ||
        (!initialLoaded && (
          <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
            <CircularProgress />
          </Box>
        ))}
    </div>
  );
}
